import { render, staticRenderFns } from "./AgencyCompanies.vue?vue&type=template&id=955bf9f6"
import script from "./AgencyCompanies.vue?vue&type=script&lang=js"
export * from "./AgencyCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports